export const LOCAL_STORAGE_AUTH_RETURN_URL = 'authReturnUrl';
export const LOCAL_STORAGE_AUTH_LAST_ACTIVITY = 'auth_last_activity';
export const LOCAL_STORAGE_AUTH_SESSION_ENDED_AT = 'auth_session_ended_at';
export const LOCAL_STORAGE_AUTH_LOGOUT = 'auth_logout';
export const LOCAL_STORAGE_AUTH_STATE_RECOVERY_AT = 'auth_state_recovery_at';

// Identity token requests and the silent sign-in give up after this, so an
// Identity that does not answer ends in an error instead of a wait.
export const IDENTITY_REQUEST_TIMEOUT_SECONDS = 10;
